var GdsAccordionHeaderOption;
(function (GdsAccordionHeaderOption) {
  GdsAccordionHeaderOption["primary"] = "primary";
  GdsAccordionHeaderOption["secondary"] = "secondary";
  GdsAccordionHeaderOption["tertiary"] = "tertiary";
})(GdsAccordionHeaderOption || (GdsAccordionHeaderOption = {}));

var GdsAccordionContentOption;
(function (GdsAccordionContentOption) {
  GdsAccordionContentOption["none"] = "";
  GdsAccordionContentOption["default"] = "default";
  GdsAccordionContentOption["inset"] = "inset";
})(GdsAccordionContentOption || (GdsAccordionContentOption = {}));

var TagTypes;
(function (TagTypes) {
  TagTypes["H1"] = "h1";
  TagTypes["H2"] = "h2";
  TagTypes["H3"] = "h3";
  TagTypes["H4"] = "h4";
  TagTypes["H5"] = "h5";
  TagTypes["H6"] = "h6";
})(TagTypes || (TagTypes = {}));

var GdsButtonTypes;
(function (GdsButtonTypes) {
  GdsButtonTypes["primary"] = "primary";
  GdsButtonTypes["secondary"] = "secondary";
  GdsButtonTypes["secondaryOutline"] = "secondary-outline";
  GdsButtonTypes["secondaryOutlineReverse"] = "secondary-outline-reverse";
  GdsButtonTypes["tertiary"] = "tertiary";
  GdsButtonTypes["tertiarySmall"] = "tertiary-small";
  GdsButtonTypes["tertiaryReverse"] = "tertiary-reverse";
  GdsButtonTypes["heading"] = "heading";
  GdsButtonTypes["subheading"] = "subheading";
  GdsButtonTypes["nav"] = "nav";
  GdsButtonTypes["navSearch"] = "nav-search";
  GdsButtonTypes["navTertiary"] = "nav-tertiary";
  GdsButtonTypes["inverted"] = "inverted";
  GdsButtonTypes["play"] = "play";
  GdsButtonTypes["gallery"] = "gallery";
  GdsButtonTypes["close"] = "close";
  GdsButtonTypes["pagination"] = "pagination";
  GdsButtonTypes["leftArrow"] = "left-arrow";
  GdsButtonTypes["rightArrow"] = "right-arrow";
  GdsButtonTypes["commerce"] = "commerce";
  GdsButtonTypes["add"] = "add";
  GdsButtonTypes["subtract"] = "subtract";
  GdsButtonTypes["chip"] = "chip";
  GdsButtonTypes["filter"] = "filter";
  GdsButtonTypes["hamburgerNavPrimary"] = "hamburger-nav-primary";
  GdsButtonTypes["hamburgerNavSecondary"] = "hamburger-nav-secondary";
  GdsButtonTypes["hamburgerNavHeadingLink"] = "hamburger-nav-heading-link";
  GdsButtonTypes["media"] = "media";
})(GdsButtonTypes || (GdsButtonTypes = {}));

var GdsFormFieldLabelPosition;
(function (GdsFormFieldLabelPosition) {
  GdsFormFieldLabelPosition["right"] = "right";
  GdsFormFieldLabelPosition["top"] = "top";
})(GdsFormFieldLabelPosition || (GdsFormFieldLabelPosition = {}));

var GdsHeroTypes;
(function (GdsHeroTypes) {
  GdsHeroTypes["static"] = "static";
  GdsHeroTypes["media"] = "media";
})(GdsHeroTypes || (GdsHeroTypes = {}));

var HhnCalendarDirection;
(function (HhnCalendarDirection) {
  HhnCalendarDirection[HhnCalendarDirection["next"] = 0] = "next";
  HhnCalendarDirection[HhnCalendarDirection["previous"] = 1] = "previous";
})(HhnCalendarDirection || (HhnCalendarDirection = {}));

var CalendarTypes;
(function (CalendarTypes) {
  // expandable to have other types
  CalendarTypes["commerce"] = "commerce";
  CalendarTypes["hhn"] = "hhn";
})(CalendarTypes || (CalendarTypes = {}));

var GdsInputTypes;
(function (GdsInputTypes) {
  GdsInputTypes["checkbox"] = "checkbox";
  GdsInputTypes["radio"] = "radio";
  GdsInputTypes["text"] = "text";
  GdsInputTypes["email"] = "email";
  GdsInputTypes["password"] = "password";
  GdsInputTypes["number"] = "number";
  GdsInputTypes["tel"] = "tel";
  GdsInputTypes["range"] = "range";
  GdsInputTypes["reset"] = "reset";
  GdsInputTypes["submit"] = "submit";
  GdsInputTypes["url"] = "url";
  GdsInputTypes["search"] = "search";
  GdsInputTypes["date"] = "date";
  GdsInputTypes["time"] = "time";
  GdsInputTypes["datetime"] = "datetime";
  GdsInputTypes["month"] = "month";
  GdsInputTypes["week"] = "week";
  GdsInputTypes["color"] = "color";
  GdsInputTypes["file"] = "file";
  GdsInputTypes["textarea"] = "textarea";
})(GdsInputTypes || (GdsInputTypes = {}));

var imageCropOptions;
(function (imageCropOptions) {
  imageCropOptions["circle"] = "circle";
  imageCropOptions["square"] = "square";
  imageCropOptions["none"] = "none";
})(imageCropOptions || (imageCropOptions = {}));

export { CalendarTypes as C, GdsAccordionHeaderOption as G, HhnCalendarDirection as H, TagTypes as T, GdsAccordionContentOption as a, GdsButtonTypes as b, GdsFormFieldLabelPosition as c, GdsHeroTypes as d, GdsInputTypes as e, imageCropOptions as i };

